import React from 'react';

import { Surface } from '@infoods/lifebase-ui';

import classes from './NgzChallengePaymentResult.module.scss';
import { angularizeWithProviders } from '../../../shared/providers';
import { collectSearchParams } from '../../utils/collectSearchParams/collectSearchParams';
import { useChallengePaymentResult } from './hooks/useChallengePaymentResult';
import { ErrorInfo } from '../../components/payment-result/ErrorInfo/ErrorInfo';
import { SuccessfulResult } from './components/SuccessfulResult/SuccessfulResult';

const NgzChallengePaymentResult = () => {
  const { paymentInfo, isSuccess, retryPath } = useChallengePaymentResult();

  // We should take the params from the URL before the '#!' part and move them after it
  // Stripe adding own params as a default query params, and we need to move them to the hash portion to be able angular router use them
  if (window.location.search.length) {
    collectSearchParams('challenge-payment-result');

    return null;
  }

  const renderContent = () => {
    if (!isSuccess) {
      return <ErrorInfo retryPath={retryPath} />;
    }

    if (!paymentInfo) {
      return null;
    }

    return (
      <Surface className={classes.box}>
        <SuccessfulResult paymentInfo={paymentInfo} />
      </Surface>
    );
  };

  return <div className={classes.container}>{renderContent()}</div>;
};

angularizeWithProviders(NgzChallengePaymentResult, 'ngzChallengePaymentResult', {});
